import { PayloadRequest } from 'types/requestTypes'
import { omdApi } from '../../api'

import { EmployeeSalary, EmployeeSalaryDetail, EmployeeSalaryFare, EmployeeSalaryList } from '../types';

const employeeSalaryConfiguration = omdApi.injectEndpoints({
  endpoints: (builder) => ({
    getEmployeeSalaryConfigurationDetail: builder.query<EmployeeSalary, PayloadRequest>({
      query: (data) => ({
        url: `/v1/EmployeeSalary/Configuration/${data.id}`,
      }),
    }),
    changeEmployeeSalaryConfiguration: builder.mutation<void, EmployeeSalary>({
      query: (data) => ({
        url: `/v1/EmployeeSalary/Configuration/${data.id}`,
        method: 'PUT',
        body: data
      }),
    }),
    createEmployeeSalaryConfiguration: builder.mutation<void, EmployeeSalary>({
      query: (data) => ({
        url: `/v1/EmployeeSalary/Configuration`,
        method: 'POST',
        body: data
      }),
    }),
    deleteEmployeeSalaryConfiguration: builder.mutation<void, PayloadRequest>({
      query: (data) => ({
        url: `/v1/EmployeeSalary/Configuration/${data.id}`,
        method: 'DELETE',
      }),
    }),

    getEmployeeSalary: builder.query<EmployeeSalary, EmployeeSalaryList>({
      query: (data) => ({
        url: `/v1/EmployeeSalary`,
        params: data
      }),
    }),
    getEmployeeSalaryDetail: builder.query<EmployeeSalaryFare, EmployeeSalaryDetail>({
      query: (data) => ({
        url: `/v1/EmployeeSalary/${data.employeeId}/details`,
        params: data
      }),
    }),
  }),
})

export const {
  useChangeEmployeeSalaryConfigurationMutation,
  useCreateEmployeeSalaryConfigurationMutation,
  useDeleteEmployeeSalaryConfigurationMutation,
  useGetEmployeeSalaryConfigurationDetailQuery,
  useLazyGetEmployeeSalaryConfigurationDetailQuery,
  useGetEmployeeSalaryDetailQuery,
  useGetEmployeeSalaryQuery,
  useLazyGetEmployeeSalaryDetailQuery,
  useLazyGetEmployeeSalaryQuery
} = employeeSalaryConfiguration;
